import React from "react";
import Body from "./Body";
import { ReactComponent as BsBoxArrowRight } from "../../../../../assets/Icons/Universal/BsBoxArrowRight.svg";

const TransportCost = () => {
  const vehicles = [
    {
      itemCode: "TRN001",
      vehicleNo: "WB 87 H 2390",
      routeNo: "25",
      dueAmount: 2300,
      date: "02 Oct, 2025",
      reporter: "Samiul Ittefak",
    },
    {
      itemCode: "TRN002",
      vehicleNo: "WB 32 B 1245",
      routeNo: "17",
      dueAmount: 1850,
      date: "03 Oct, 2025",
      reporter: "Anjali Thapa",
    },
    {
      itemCode: "TRN003",
      vehicleNo: "WB 58 G 7852",
      routeNo: "42",
      dueAmount: 2750,
      date: "04 Oct, 2025",
      reporter: "Manoj Koirala",
    },
    {
      itemCode: "TRN004",
      vehicleNo: "BR 01 C 9342",
      routeNo: "08",
      dueAmount: 2100,
      date: "05 Oct, 2025",
      reporter: "Rina Pandey",
    },
    {
      itemCode: "TRN005",
      vehicleNo: "WB 12 E 3331",
      routeNo: "33",
      dueAmount: 1920,
      date: "06 Oct, 2025",
      reporter: "Prakash Tamang",
    },
    {
      itemCode: "TRN006",
      vehicleNo: "AS 07 D 6611",
      routeNo: "15",
      dueAmount: 2250,
      date: "07 Oct, 2025",
      reporter: "Nikita Sharma",
    },
    {
      itemCode: "TRN007",
      vehicleNo: "JH 05 A 8720",
      routeNo: "21",
      dueAmount: 2080,
      date: "08 Oct, 2025",
      reporter: "Ajay Chaudhary",
    },
    {
      itemCode: "TRN008",
      vehicleNo: "OR 19 Q 4473",
      routeNo: "19",
      dueAmount: 2430,
      date: "09 Oct, 2025",
      reporter: "Sunita Yadav",
    },
    {
      itemCode: "TRN009",
      vehicleNo: "WB 10 Z 1010",
      routeNo: "28",
      dueAmount: 1990,
      date: "10 Oct, 2025",
      reporter: "Hari Prasad",
    },
    {
      itemCode: "TRN010",
      vehicleNo: "BR 22 L 9898",
      routeNo: "06",
      dueAmount: 2600,
      date: "11 Oct, 2025",
      reporter: "Asha Lama",
    },
  ];

  const vehicleHeaders = [
    { key: "vehicleNo", label: "Vehicle No." },
    { key: "routeNo", label: "Route No." },
    { key: "dueAmount", label: "Due amount (INR)" },
    { key: "reporter", label: "Reported by" },
  ];

  const transportTableData = [
    {
      date: "27 Dec, 2024",
      time: "10:24 AM",
      receiptId: "23457289056",
      vehicles: [
        { vehicleNo: "WB 87 H 2390", routeNo: 25, amount: 18000 },
        { vehicleNo: "WB 90 J 2386", routeNo: 36, amount: 18000 },
      ],
      totalAmount: 36000,
      paidAmount: 18000,
      paymentMethod: "UPI",
      vendor: {
        name: "Mahi Enterprise",
        phone: "9876543210",
      },
      confirmedBy: "Jaheer Ahmad",
    },
    {
      date: "27 Dec, 2024",
      time: "10:24 AM",
      receiptId: "23457289056",
      vehicles: [
        { vehicleNo: "WB 87 H 2390", routeNo: 25, amount: 18000 },
        { vehicleNo: "WB 90 J 2386", routeNo: 36, amount: 18000 },
      ],
      totalAmount: 36000,
      paidAmount: 36000,
      paymentMethod: "Net banking",
      vendor: {
        name: "Mahi Enterprise",
        phone: "9876543210",
      },
      confirmedBy: "Jaheer Ahmad",
    },
    {
      date: null,
      time: "10:24 AM",
      receiptId: "23457289056",
      vehicles: [
        { vehicleNo: "WB 87 H 2390", routeNo: 25, amount: 18000 },
        { vehicleNo: "WB 90 J 2386", routeNo: 36, amount: 18000 },
      ],
      totalAmount: 36000,
      paidAmount: 18000,
      paymentMethod: "Debit card",
      vendor: {
        name: "Mahi Enterprise",
        phone: "9876543210",
      },
      confirmedBy: "Jaheer Ahmad",
    },
    {
      date: null,
      time: "10:24 AM",
      receiptId: "23457289056",
      vehicles: [
        { vehicleNo: "WB 87 H 2390", routeNo: 25, amount: 18000 },
        { vehicleNo: "WB 90 J 2386", routeNo: 36, amount: 18000 },
      ],
      totalAmount: 36000,
      paidAmount: 18000,
      paymentMethod: "Cash",
      vendor: {
        name: "Mahi Enterprise",
        phone: "9876543210",
      },
      confirmedBy: "Jaheer Ahmad",
    },
    {
      date: "27 Dec, 2024",
      time: "10:24 AM",
      receiptId: "23457289056",
      vehicles: [
        { vehicleNo: "WB 87 H 2390", routeNo: 25, amount: 18000 },
        { vehicleNo: "WB 90 J 2386", routeNo: 36, amount: 18000 },
      ],
      totalAmount: 36000,
      paidAmount: 18000,
      paymentMethod: null,
      vendor: {
        name: "Mahi Enterprise",
        phone: "9876543210",
      },
      confirmedBy: "Jaheer Ahmad",
    },
  ];

  const columns = [
    {
      label: "Receipt id/Time",
      key: "receiptId",
      render: (row) => (
        <>
          {row.receiptId}
          <br />
          <span style={{ color: "var(--orangeColor)", fontSize: "small" }}>
            {row.time}
          </span>
        </>
      ),
    },
    {
      label: "Vehicle No.",
      key: "vehicleNo",
      render: (row) =>
        row.vehicles.map((v, i) => <div key={i}>{v.vehicleNo}</div>),
    },
    {
      label: "Route No.",
      key: "routeNo",
      render: (row) =>
        row.vehicles.map((v, i) => <div key={i}>{v.routeNo}</div>),
    },
    {
      label: "Amount (INR)",
      key: "amount",
      render: (row) => (
        <>
          {row.vehicles.map((v, i) => (
            <div key={i}>₹ {Number(v.amount).toLocaleString("en-IN")}</div>
          ))}
          <div style={{ borderTop: "1px solid black", marginTop: "4px" }}>
            Total:{" "}
            <span style={{ color: "var(--blueColor1)" }}>
              ₹ {Number(row.totalAmount).toLocaleString("en-IN")}
            </span>
          </div>
        </>
      ),
    },
    {
      label: "Paid amount (INR)",
      key: "paidAmount",
      render: (row) => (
        <>
          ₹ {Number(row.paidAmount).toLocaleString("en-IN")}
          <br />
          <span style={{ color: "var(--deepGreen3)", fontSize: "small" }}>
            {row.paymentMethod}
          </span>
        </>
      ),
    },
    {
      label: "Pay to",
      key: "vendor",
      render: (row) => (
        <>
          {row.vendor.name}
          <br />
          Ph:{" "}
          <span style={{ color: "var(--blueColor1)" }}>{row.vendor.phone}</span>
        </>
      ),
    },
    {
      label: "Confirmed by",
      key: "confirmedBy",
      render: (row) => (
        <span style={{ color: "var(--deepGreen3)" }}>{row.confirmedBy}</span>
      ),
    },
    {
      label: "Receipts",
      key: "receipts",
      render: (row) => (
        <>
          <span
            style={{
              color: "var(--blueColor1)",
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              cursor: "pointer",
            }}
          >
            Receipt <BsBoxArrowRight />
          </span>
          <br />
          <button
            className="action-pay-btn"
            style={{
              backgroundColor:
                row.paidAmount < row.totalAmount
                  ? "var(--tableColor)"
                  : "var(--deepGreen3)",
              borderColor:
                row.paidAmount < row.totalAmount
                  ? "var(--tableColor)"
                  : "var(--deepGreen3)",
            }}
          >
            {row.paidAmount < row.totalAmount ? "Pay due" : "All paid"}
          </button>
        </>
      ),
    },
  ];

  // Sample dropdown data
  const confirmedByOptions = ["Admin", "Finance Head", "CEO"];
  const paymentModes = ["Cash", "UPI", "Bank Transfer", "Cheque"];
  const _this = {
    vehicles,
    vehicleHeaders,
    transportTableData,
    columns,
    confirmedByOptions,
    paymentModes,
  };
  return <Body {..._this} />;
};

export default TransportCost;
